module.exports = (s) => {
  return {
    /** 推荐类别 */
    recommend_category: {
      type: 'select',
      options: [
        { label: '以词拓词', value: 'RECOMMEND_BY_WORD' },
        { label: '行业拓词', value: 'RECOMMEND_BY_INDUSTRY' },
      ],
      value: 'RECOMMEND_BY_WORD',
      on: {
        change: (val) => {
          s.recommendCategoryChange(val);
        },
      },
    },
    /** 以词拓词 - 种子词集合 */
    query_word: {
      value: [],
      temp_value: '',
      hidden: false,
      rules: {
        require: true,
        trigger: ['change'],
        validator: (rule, value, callback) => {
          if (value.length) {
            callback();
          } else {
            callback(new Error('请添加关键词'));
          }
        },
      },
    },
    /** 行业拓词 - 业务点id */
    business_point_id: {
      type: 'cascader',
      props: {
        props: {
          label: 'desc',
          value: 'value',
          children: 'options',
          emitPath: false,
          checkStrictly: true,
        },
      },
      options: [],
      value: null,
      hidden: true,
      rules: { required: true, message: '请选择业务点id', trigger: 'change' },
    },
  };
};
